import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AutomaticPointsSettingsPageRoutingModule } from './automatic-points-settings-routing.module';

import { AutomaticPointsSettingsPage } from './automatic-points-settings.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AutomaticPointsSettingsPageRoutingModule
  ],
  declarations: [AutomaticPointsSettingsPage]
})
export class AutomaticPointsSettingsPageModule {}
